import {Tool} from "../api";

// Derived from the generated Tool.stage type, which is defined in api/openapi.yaml
// (single source of truth, kept in sync with backend/src/main/kotlin/de/guude_ai/tools/domain.kt).
export const TOOL_STAGE_STANDARD: Tool["stage"] = "ultravox-call";
export const TOOL_STAGE_INBOUND: Tool["stage"] = "ultravox-inbound-call";
export const TOOL_STAGE_TWILIO: Tool["stage"] = "twilio";

export type ToolMode = "standard" | "inbound" | "twilio";